import { callGetMerchandiseShippingDetails } from "repoV2/features/Listing/utils/callGetMerchandiseShippingDetails";
import { isRequestSuccessful } from "repoV2/utils/common/api/api";
import { logError } from "repoV2/utils/common/error/error";

export const checkMerchandiseShipping = async ({
    listingUuid,
    currencyName,
    isInternationalEnabled,
    pinCode,
    variantUuid,
}: {
    listingUuid: string;
    currencyName: string;
    isInternationalEnabled: boolean;
    pinCode?: string;
    variantUuid?: string;
}) => {
    try {
        const response = await callGetMerchandiseShippingDetails({
            listingUuid,
            currency: currencyName || "",
            isInternationalEnabled,
            pinCode,
            variantUuid,
        });

        if (isRequestSuccessful(response?.status)) {
            const shippingDetails = response?.data?.data || {};
            return {
                ...shippingDetails,
                isError: false,
            };
        }
    } catch (err) {
        logError({
            error: err,
            when: "api to get shipping details",
            occuredAt:
                "repoV2/features/CheckoutPages/modules/PaymentDetailsSection/modules/FormGroups/modules/MerchandiseDetailsFormGroup/utils/checkMerchandiseShipping.ts",
        });
        return {
            isError: true,
            shipping_charge: 0,
            shipping_days: 0,
        };
    }
};
